__webpack_require__.p = "/nytimes/";